import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { insertReservation } from 'modules/accommodations/features/reservations/api';

export const useMutationInsertReservation = () => {
  const queryClient = useQueryClient();
  const { errorToast } = useCustomToast();

  const { mutateAsync, isLoading, isError, data } = useMutation(insertReservation, {
    onSettled: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_INSERT_NEW_RESERVATION);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_INSERT_NEW_RESERVATION);
    },
    onError: () => errorToast(),
  });

  return {
    insertNewReservationMutation: mutateAsync,
    newReservationLoading: isLoading,
    newReservationError: isError,
    insertedCalculationId: data,
  };
};
